import { NavLink } from 'react-router-dom';
import { NotificationBell } from './NotificationBell.jsx';
import { NAV_LINKS } from './navLinks.js';

export function Sidebar({ isAdmin, notifications, unreadCount, markRead, markAllRead }) {
  return (
    <nav className="sidebar" aria-label="Main navigation">
      <NavLink to="/dashboard" className="sidebar-title">Speaker Tracker</NavLink>
      <ul className="sidebar-nav sidebar-nav-top">
        {NAV_LINKS.map((link) => (
          <li key={link.to}>
            <NavLink
              to={link.to}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              <span className="nav-icon" aria-hidden="true">{link.icon}</span>
              {link.label}
            </NavLink>
          </li>
        ))}

        {isAdmin && (
          <>
            <li>
              <NavLink
                to="/admin/users"
                className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              >
                <span className="nav-icon" aria-hidden="true">⚙</span>
                User Administration
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/orgs"
                className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              >
                <span className="nav-icon" aria-hidden="true">🏢</span>
                Organizations
              </NavLink>
            </li>
          </>
        )}
      </ul>

      <div className="sidebar-footer">
        <div className="between">
          <span>Notifications</span>
          <NotificationBell
            notifications={notifications}
            unreadCount={unreadCount}
            markRead={markRead}
            markAllRead={markAllRead}
          />
        </div>
        <NavLink to="/dashboard" className="sidebar-logo-footer">
          <img src="/logo.png" alt="Speaker Tracker" className="sidebar-logo-img" />
        </NavLink>
        <p className="sidebar-copyright">© 2026 Holistic Agility and Logistics, LLC</p>
      </div>
    </nav>
  );
}
